<template>
  <b-row v-if="queryData" align-h="between">
    <b-col cols="px-0 px-sm-3">
      <p class="table-results">
        Displaying
        {{ queryData.paginationFrom ? queryData.paginationFrom : '..' }} -
        {{ queryData.paginationTo ? queryData.paginationTo : '..' }}
        of {{ queryData.rows ? queryData.rows : '..' }} results
      </p>
    </b-col>
    <b-col class="px-0 px-sm-3">
      <b-pagination
        v-if="queryData.rows > queryData.limit"
        v-model="queryData.page"
        class="float-left float-sm-right"
        :total-rows="queryData.rows"
        :per-page="queryData.limit"
        aria-controls="my-table"
        @input="onPaginate"
      />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'ErrorAlert',

  props: {
    queryData: {
      type: Object,
      required: true,
    },
  },

  methods: {
    onPaginate() {
      this.$parent.onPaginate(this.queryData.page);
    },
  },
};
</script>
